import { useMutation } from '@apollo/client'
import {
  CreateInstitutionalCodes,
  CreateInstitutionalCodesVariables,
} from '__generatedTypes__/CreateInstitutionalCodes'
import { CREATE_INSTITUTIONAL_CODES } from 'queries/institutionalCodes'

export function useCreateInstitutionalCodesMutation() {
  return useMutation<CreateInstitutionalCodes, CreateInstitutionalCodesVariables>(CREATE_INSTITUTIONAL_CODES)
}
